<template>
  <div v-if="showError"
     class="nuttrema-form-alert"
    :class="[theme ? `theme-${theme}` : '', { 'in-east-layout': eastLayout }]">

    <a class="delete" @click.stop="destroyError()"></a>

    <div class="nuttrema-form-alert__message">
      <div class="message__title">
        {{ showError.error }}
      </div>
      <div class="message__text">
        <ul v-if="errors">
          <li v-for="errorItem in errors">
            {{ errorItem.message }}
          </li>
        </ul>
        <p v-else-if="message">
          {{ message }}
        </p>
      </div>
    </div>

    <div class="nuttrema-form-alert__icon">
      <i class="far fa-exclamation"></i>
    </div>

  </div>
</template>

<script>
import { has, cloneDeep } from 'lodash';

export default {
  name: 'nuttrema-form-alert',
  props: {
    error: {
      required: true,
      default: null,
    },
    eastLayout: {
      required: false,
      default: false,
    },
    theme: {
      required: false,
      default: 'is-danger',
    },
  },
  methods: {
    destroyError() {
      this.showError = null;
      this.$emit('close');
    },
  },
  computed: {
    message() {
      return has(this.showError, 'message') ? this.showError.message : false;
    },
    errors() {
      return has(this.showError, 'validation.errors') ? this.showError.validation.errors : false;
    },
  },
  data() {
    return {
      show: false,
      showError: false,
    };
  },
  created() {
    this.showError = cloneDeep(this.error);
  },
  watch: {
    error(newValue) {
      this.showError = cloneDeep(newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
  @import './nuttrema-alert-colors';

  .nuttrema-form-alert {
    flex-grow: 1;
    display: flex;
    // flex-shrink: 0;
    overflow: hidden;
    position: relative;
    justify-content: space-between;

    border-radius: 0.5em;
    padding: 1em 1.5em 1.25em 1.5em;

    a.delete {
      top: 0.5em;
      right: 0.5em;
      position: absolute;
      &:hover {
        cursor: pointer;
      }
    }

    .nuttrema-form-alert__message {
      flex-grow: 1;
      display: flex;
      flex-direction: column;
      justify-content: center;

      .message__title {
        line-height: 2;
        font-weight: 500;
      }

      .message__text {
        font-size: 0.95rem;
      }
    }

    .nuttrema-form-alert__icon {
      display: flex;
      min-width: 5em;
      position: relative;
      align-items: center;
      justify-content: center;

      > i {
        font-size: 6em;
        position: absolute;
        right: 14px;
      }
    }

    &.theme-is-danger {
      color: $pink-color;
      background-color: $pink-bg-color;
      .nuttrema-form-alert__icon {
        > i {
          color: $pink-icon-color;
        }
      }
    }

    &.in-east-layout {
      margin: 0.75em 0.5em;
    }

    &.is-extra-mb-100 {
      margin-bottom: 1em;
    }
  }


</style>



// WEBPACK FOOTER //
// src/components/ui/alert/nuttrema-form-alert.vue